import UserIndex from '@/Libs/Pages/Panel/User/UserIndex.vue'
import UserForm from '@/Libs/Pages/Panel/User/UserForm.vue'
import StuffTypeIndex from '@/Libs/Pages/Panel/StuffType/StuffTypeIndex.vue'
import StuffTypeForm from '@/Libs/Pages/Panel/StuffType/StuffTypeForm.vue'

export default [
    {
        name: 'user',
        path: '/user',
        component: UserIndex,
        meta: {
            title: 'user.title.list',
            permission: 'user_list'
        },
    },
    {
        name: 'user-create',
        path: '/user/create',
        component: UserForm,
        meta: {
            title: 'user.title.create',
            permission: 'user_create'
        },
    },
    {
        name: 'user-detail',
        path: '/user/detail/:id',
        component: UserForm,
        meta: {
            title: 'user.title.detail',
            permission: 'user_show'
        },
    },
    {
        name: 'stuff-type',
        path: '/stuff-type',
        component: StuffTypeIndex,
        meta: {
            title: 'stuff_type.title.list',
            permission: 'stuff_type_list'
        },
    },
    {
        name: 'stuff-type-create',
        path: '/stuff-type/create',
        component: StuffTypeForm,
        meta: {
            title: 'stuff_type.title.create',
            permission: 'stuff_type_create'
        },
    },
    {
        name: 'stuff-type-detail',
        path: '/stuff-type/detail/:id',
        component: StuffTypeForm,
        meta: {
            title: 'stuff_type.title.detail',
            permission: 'stuff_type_show'
        },
    }
];